import { ChartContainer } from "../../../style/style";
import { Line } from "react-chartjs-2";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { PGET } from "../../../api/adminApi";
import { Row } from "antd";
import Select from "react-select";
import CustomDatePicker from "../../common/CustomDatePicker";
import moment from "moment";

export const LineChartMonthlyType = (props) => {
  const [selectedDate, setSelectedDate] = useState(moment());
  const [labels, setLabels] = useState([]);
  const [datasets, setDatasets] = useState([]);
  const [selectedOption, setSelectedOption] = useState({
    label: "Общий",
    value: 0,
  });
  const [dateRange, setDateRange] = useState([
    new Date("2026-01-01"),
    new Date("2027-01-01"),
  ]);
  const [startDate, endDate] = dateRange;
  const selectOptions = [
    { label: "Общий", value: 0 },
    { label: "Секционный", value: 1 },
    { label: "Панельный", value: 2 },
    { label: "Котел", value: 3 },
  ];

  async function getItems(year, month, type) {
    const queryUrl = `${props.url}${year}/${month}`;
    const data = await PGET(queryUrl, true, {});
    const daysInMonth = new Date(year, month, 0).getDate();
    const newLabels = Array.from({ length: daysInMonth }, (_, i) => i + 1);
    setLabels(newLabels);
    const newData = new Array(daysInMonth).fill(0);
    data.data.forEach((item) => {
      if (item.dayNumber && item.dayNumber <= daysInMonth) {
        if (props.request) {
          newData[item.dayNumber - 1] = item.requestsCount;
        } else {
          newData[item.dayNumber - 1] = item.registrationCount;
        }
      }
    });

    const newDataset = [
      {
        data: newData,
        borderColor: "#1ce1ac",
        borderWidth: 1,
        fill: false,
      },
    ];
    setDatasets(newDataset);
  }

  const { options, height, width, id } = props;
  const data = {
    labels,
    datasets,
  };
  const maxValue = datasets[0]?.data ? Math.max(...datasets[0].data) * 2 : 0;
  const updatedOptions = {
    ...options,
    scales: {
      y: {
        min: 0,
        max: maxValue,
        ticks: {
          precision: 0,
        },
      },
    },
  };

  useEffect(() => {
    getItems(
      selectedDate.year(),
      selectedDate.month() + 1,
      selectedOption.value
    );
  }, [selectedDate, selectedOption]);

  const handleChange = (selected) => {
    setSelectedOption(selected);
  };

  return (
    <div className="line-chart-container">
      <Row className="mt-2 flex justify-end">
        {/*<div style={{width: 200, position: "absolute", right: 10, top: 16}}>*/}
        {/*  <CustomDatePicker*/}
        {/*      selected={startDate}*/}
        {/*      onChange={(date) => setDateRange([date, date])}*/}
        {/*      isClearable={true}*/}
        {/*      className="datepicker-custom-input-dash !h-[36px]"*/}
        {/*  />*/}
        {/*</div>*/}
        {/*<div style={{width: 200, position: "absolute", right: 10, top: 15}}>*/}
        {/*  <Select*/}
        {/*      name="regionId"*/}
        {/*      className="custom-react-select"*/}
        {/*      options={selectOptions}*/}
        {/*      value={selectedOption}*/}
        {/*      style={{height: 30}}*/}
        {/*      onChange={handleChange}*/}
        {/*  />*/}
        {/*</div>*/}
      </Row>
      <ChartContainer className="chart-container">
        <Line
          id={id && id}
          width={width}
          data={data}
          height={height}
          options={updatedOptions}
        />
      </ChartContainer>
    </div>
  );
};

LineChartMonthlyType.defaultProps = {
  height: 300,
  width: null,
  options: {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
      },
    },
    legend: {
      display: false,
      labels: {
        display: false,
      },
    },
  },
};

LineChartMonthlyType.propTypes = {
  height: PropTypes.number,
  labels: PropTypes.arrayOf(PropTypes.string),
  datasets: PropTypes.arrayOf(PropTypes.object),
  layout: PropTypes.object,
  width: PropTypes.number,
  options: PropTypes.object,
  id: PropTypes.string,
};
